import type { CalendarItemPayload } from './schema';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import { AssetAriaLabel, registerAsset } from 'owa-timestream-asset-sdk';
import { registerSearchableAsset } from 'owa-timestream-asset-search';
import TxpOrCalendarItemView from './components/TxpOrCalendarItemView';
import {
    default as CalendarSearchResult,
    CalendarSearchResultProps,
} from './components/CalendarSearchResult';
import searchAsset from './utils/searchAsset';
import { createDragAsset } from './utils/createDragAsset';
import { getSearchFilterOptions, getResultFilterOptions } from './utils/filterAssets';
import compareAssets from './utils/compareAssets';
import getSearchResultHeaders from './utils/getSearchResultHeaders';
import loc from 'owa-localize';
import {
    calendarItemName,
    pivotHeader,
    assetErrorEvent,
} from './calendarItemStrings.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import popoutCalendarItem from './utils/popoutCalendarItem';

// import orchestrators
import './orchestrators/orchestrators';

const CALENDAR_ITEM_TYPE = 'calendarItem';

export const calendarItem = registerAsset<CalendarItemPayload>({
    type: CALENDAR_ITEM_TYPE,
    iconName: ControlIcons.Calendar,
    getToolName: () => loc(calendarItemName),
    getErrorMessage: () => loc(assetErrorEvent),
    createEmptyAsset: () => ({
        type: CALENDAR_ITEM_TYPE,
        payload: {} as CalendarItemPayload,
    }),
    unsupportedDefaultCommands: [],
    customRenderDueDate: true,
    CanvasView: TxpOrCalendarItemView,
    onAssetInvoked: popoutCalendarItem,
    getAriaLabel: getCalendarItemAriaLabelName,
    getTitleString: getCalendarItemSubject,
    getSearchString: getCalendarItemSearchString,
});

function getCalendarItemSubject(payload: CalendarItemPayload) {
    return payload.item?.Subject || loc(noSubject);
}

function getCalendarItemAriaLabelName(payload: CalendarItemPayload) {
    return loc(
        AssetAriaLabel.assetAriaLabel,
        loc(calendarItemName),
        getCalendarItemSubject(payload)
    );
}

function getCalendarItemSearchString(payload: CalendarItemPayload) {
    return payload.item?.Subject + ' ' + (payload.item?.Preview ?? '');
}

export const calendarSearchItem = registerSearchableAsset<
    CalendarSearchResultProps,
    CalendarItemPayload
>({
    type: CALENDAR_ITEM_TYPE,
    getHeaderLabel: () => loc(pivotHeader),
    createDragAsset: createDragAsset,
    SearchView: CalendarSearchResult,
    searchAsset: searchAsset,
    getSearchFilterOptions: getSearchFilterOptions,
    getResultFilterOptions: getResultFilterOptions,
    compareAssets: compareAssets,
    getSearchResultHeaders: getSearchResultHeaders,
});
